import * as React from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useFetchOperation } from '../../service/Operation';
import { useAppDispatch, useAppSelector } from '../../store';
import { trainingActionCreators } from '../../store/Training';
import { TrainingCard } from '../../types/TrainingTypes';
import ProgressButton from '../general/ProgressButton';

export default function CardActionsDropdown(props: { card: TrainingCard }) {
    const dispatch = useAppDispatch();
    const auth = useAppSelector(state => state.auth);
    const [marking, startMarking, resetMarking] = useFetchOperation(onMarkSuccess);

    function skipCard() {
        dispatch(trainingActionCreators.skip());
    }

    function markCard() {
        startMarking('post', `api/marks/${props.card.id}`);
    }

    function onMarkSuccess() {
        setTimeout(resetMarking, 1000);
    }

    return (
        <>
            <Dropdown className="d-inline-block panel-btn">
                <Dropdown.Toggle variant="outline-primary"
                    className="btn btn-sm btn-outline-primary btn-wide" >
                    Card actions
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item as={Button}
                        variant="outline"
                        onClick={skipCard}>
                        Don't study
                    </Dropdown.Item>

                    <Dropdown.Item as={ProgressButton}
                        variant="outline"
                        size="sm"
                        className="btn-wide"
                        onClick={markCard}
                        active={marking.active}
                        success={marking.success}
                        text="Send to check"
                        successText="Sent to check">
                    </Dropdown.Item>

                    {auth.isModerator &&
                        <Dropdown.Item as={Link}
                            to={`/cards/${props.card.id}/similar`}
                            className="btn btn-sm btn-outline btn-wide"
                            state={true}>
                            Similar
                        </Dropdown.Item>
                    }
                    {props.card.modeInfo.isEditable &&
                        <Dropdown.Item as={Link}
                            to={`/cards/${props.card.id}`}
                            className="btn btn-sm btn-outline btn-wide">
                            Edit
                        </Dropdown.Item>
                    }
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
}
